import AuthLayout from 'pages/onboarding/components/AuthLayout';
import AuthSplitShell from 'pages/onboarding/components/AuthSplitShell';
import ExaminationRegister from '.';

const PublicExaminationPage = () => {
  return (
    <AuthLayout skipMe>
      <AuthSplitShell>
        <ExaminationRegister />
      </AuthSplitShell>
    </AuthLayout>
  );
};

export default PublicExaminationPage;
